import { render, staticRenderFns } from "./PagePurchaseHistory.vue?vue&type=template&id=0e4767f2&scoped=true&"
import script from "./PagePurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./PagePurchaseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4767f2",
  null
  
)

export default component.exports